import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import { useAppContext } from '../../context';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';


interface PopUpProps {
    open: boolean;
    title?: string;
    children: React.ReactNode;
    onClose: () => void;
    onConfirm?: () => void;
    confirmText?: string;
    cancelText?: string;
}

const PopUp: React.FC<PopUpProps> = ({
    open,
    title,
    children,
    onClose,
}) => {
    const { showPopUpCalculate } = useAppContext();
    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    overflow: "hidden",
                    maxWidth: { xs: "90%", md: "1000px" },
                    maxHeight: "calc(100% - 15px) !important",
                    ...(showPopUpCalculate ? { width: "400px", height: "300px" } : { width: "auto", height: "auto" }),
                },
            }}

        >
            <IconButton
                aria-label="close"
                onClick={onClose}
                sx={(theme) => ({
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: theme.palette.grey[500],
                })}
            >
                <CloseIcon />
            </IconButton>
            
            {/* {title && <Verification />} */}
            
            { title && <DialogTitle>{title}</DialogTitle>}
            <DialogContent dividers sx={{
                p: 0,
                display: "flex",
                justifyContent: "center", // ვერტიკალურად
                alignItems: "center",     // ჰორიზონტალურად
                height: "100%",
            }}>
                {children}
            </DialogContent>
        </Dialog>
    );
};

export default PopUp;
